import type React from "react";

import { IconButton } from "@/design-system/IconButton";
import { ClosableNotice, Notice } from "@/design-system/Notice";
import { useTranslation } from "@/translations";

import { XCloseIcon } from "../Icons/XCloseIcon";

interface AskNobiChatInputNoticeProps {
  variant: "success" | "warning" | "special";
  text: React.ReactNode;
  actions?: React.ReactNode;
  onClose?: () => void;
}

export function AskNobiChatInputNotice({
  variant,
  text,
  actions,
  onClose,
}: AskNobiChatInputNoticeProps): React.ReactNode {
  const { t } = useTranslation();

  if (onClose && !actions) {
    return <ClosableNotice variant={variant} message={text} closeLabel={t("common.action.close")} onClose={onClose} />;
  }

  return (
    <Notice
      variant={variant}
      message={text}
      actions={
        actions || onClose ? (
          <>
            {actions}
            {onClose && (
              <IconButton
                title={t("common.action.close")}
                withTooltip={false}
                onClick={onClose}
                icon={<XCloseIcon />}
                size="xs"
                variant="ghostSecondary"
              />
            )}
          </>
        ) : undefined
      }
    />
  );
}
